/**
 * Frequency configuration — single source of truth for all frequency logic
 * in the MTC Proposal system.
 */

export const FREQUENCY_OPTIONS = [
  { value: 'Daily',                  visitsPerYear: 365, visitsPerMonth: 30.417, stat: { value: '365x', label: 'Daily Service' } },
  { value: 'Three Times a Week',     visitsPerYear: 156, visitsPerMonth: 13,     stat: { value: '156x', label: '3x Weekly Service' } },
  { value: 'Twice a Week',           visitsPerYear: 104, visitsPerMonth: 8.667,  stat: { value: '104x', label: '2x Weekly Service' } },
  { value: 'Weekly',                 visitsPerYear: 52,  visitsPerMonth: 4.333,  stat: { value: '52x',  label: 'Weekly Service' } },
  { value: 'Bi-Weekly',              visitsPerYear: 26,  visitsPerMonth: 2.167,  stat: { value: '26x',  label: 'Bi-Weekly Service' } },
  { value: 'Monthly',                visitsPerYear: 12,  visitsPerMonth: 1,      stat: { value: '12x',  label: 'Annual Inspections' } },
  { value: 'Quarterly',              visitsPerYear: 4,   visitsPerMonth: 0.333,  stat: { value: '4x',   label: 'Quarterly Service' } },
  { value: 'Bi-Annually',            visitsPerYear: 2,   visitsPerMonth: 0.167,  stat: { value: '2x',   label: 'Bi-Annual Service' } },
  { value: 'Annually',               visitsPerYear: 1,   visitsPerMonth: 0.083,  stat: { value: '1x',   label: 'Annual Service' } },
  { value: 'As Needed - Included',   visitsPerYear: 0,   visitsPerMonth: 0,      stat: { value: 'PRN',  label: 'As Needed' } },
  { value: 'As Needed - Additional', visitsPerYear: 0,   visitsPerMonth: 0,      stat: { value: 'PRN',  label: 'As Needed' } },
]

const FREQUENCY_MAP = Object.fromEntries(FREQUENCY_OPTIONS.map(o => [o.value, o]))

/** Lookup with safe fallback (unknown frequencies get 0 visits) */
export const getFrequencyConfig = (frequency) =>
  FREQUENCY_MAP[frequency] || { value: frequency, visitsPerYear: 0, visitsPerMonth: 0, stat: null }

/** Calculate monthly price from per-visit price and frequency */
export const calculateMonthlyPrice = (perVisitPrice, frequency) => {
  const config = getFrequencyConfig(frequency)
  return (Number(perVisitPrice) || 0) * config.visitsPerMonth
}

/** True for any "As Needed" variant (including legacy plain "As Needed") */
export const isAsNeeded = (frequency) =>
  typeof frequency === 'string' && frequency.startsWith('As Needed')

/** Returns true for Included, false for Additional, null for priced services */
export const isIncludedWithPlan = (frequency) => {
  if (frequency === 'As Needed - Included') return true
  if (frequency === 'As Needed - Additional') return false
  return null
}

/** Returns the auto-generated first stat object for a frequency, or null */
export const getFrequencyStat = (frequency) => {
  const config = getFrequencyConfig(frequency)
  return config.stat || null
}

/** Strip the suffix (- Included / - Additional) for display purposes */
// Friendlier wording for cadences whose canonical value reads awkwardly.
const DISPLAY_LABEL_OVERRIDES = {
  'Bi-Annually': 'Twice a Year',
}

export const getFrequencyDisplayLabel = (frequency) => {
  if (!frequency) return ''
  const base = frequency.replace(/ - (Included|Additional)$/, '')
  return DISPLAY_LABEL_OVERRIDES[base] || base
}
